import "./global.css";
import ReactDOM from "react-dom";
import App from "./app/App";
import store, { persistor } from "redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={"... loading"}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
